import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CustomAvatarService {
    getShortInitials(name: string): string {
        if (!name) return '';

        return name
            .trim()
            .split(/\s+/)
            .map((word) => {
                if (/^\d/.test(word)) {
                    return word.charAt(0);
                }
                return word.charAt(0).toUpperCase();
            })
            .join('')
            .slice(0, 2);
    }
}
